export const TITLE = "Greaves Eltra City Price in 2026 - Range, Specification & Reviews | Turno";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Looking for Greaves Eltra City price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "keywords",
    content:
      "Greaves Eltra City, Greaves Eltra City price, electric commercial vehicle, Greaves electric 3-wheeler, Eltra City specifications, electric vehicle range, Greaves EV, electric vehicle price, Turno",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content:
      "https://www.turno.club/electric-commercial-vehicles/Greaves/Eltra",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content:
      "https://www.turno.club/electric-commercial-vehicles/Greaves/Eltra",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Greaves Eltra City Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    property: "og:description",
    content:
      "Looking for Greaves Eltra City price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Looking for Greaves Eltra City price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "twitter:title",
    content: "Greaves Eltra City Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content:
      "https://www.turno.club/electric-commercial-vehicles/Greaves/Eltra",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK =
  "https://www.turno.club/electric-commercial-vehicles/Greaves/Eltra";

export const HIGHLIGHTS_HEADING = "Product Highlights";

export const SUB_TEXT =
  "Introducing the Greaves Eltra electric commercial vehicle, a game-changer for all your cargo transportation needs. This robust three-wheeler electric tempo offers unparalleled performance, stability, and an impressive load-carrying capacity of 530 kg, making it the ultimate choice for your business. With 49 Nm of torque, 9.5 kW of power, and a top speed of 50 km/hour, it ensures efficient and swift deliveries.";

export const MOSTLY_BOUGHT_FOR_HEADING = "Mostly bought for";

export const BUSINESS_BENEFIT_HEADING =
  "Business Benefit with Electric Vehicle";

export const FEATURES_HEADING = "Features of Greaves Eltra";

export const BRAND_DEALER_HEADING = "Greaves Eltra Electric Truck Dealers Near Me:";

export const BRAND_DEALER_DESCRIPITION =
  "As Greaves's influence continues to extend across India, its presence is becoming increasingly noticeable. With a rising number of individuals choosing Greaves's top-notch mobility solutions, known for delivering excellent value for the price, Turno proudly presents the outstanding Greaves Eltra electric commercial vehicle, at an unbelievably budget-friendly price.";

export const FAQ_HEADING_TEXT = "FAQs on Greaves Eltra";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Greaves", href: "/electric-commercial-vehicles/Greaves" },
  { label: "Eltra" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Greaves",
      item: "https://www.turno.club/electric-commercial-vehicles/Greaves",
    },
    {
      "@type": "ListItem",
      position: 4,
      name: "Eltra",
      item: VEHICLE_LINK,
    },
  ],
};
